<template>
  <v-chip-group
    :value="index"
    active-class="selected"
    @change="onChange"
    class="selector"
    :class="{ dark: darkThemeEnabled }"
    mandatory
    v-if="editable"
  >
    <v-chip small color="success" text-color="opposite" />
    <v-chip small color="grey" />
    <v-chip small color="error" text-color="opposite" />
  </v-chip-group>
  <div v-else class="selector">
    <v-chip
      small
      v-if="value === true"
      class="mr-1"
      color="success"
      text-color="opposite"
    />
    <v-chip small v-if="value === null" class="mr-1" color="grey" />
    <v-chip
      small
      v-if="value === false"
      class="mr-1"
      color="error"
      text-color="opposite"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CustomColorChip',
  props: {
    value: {
      type: Boolean,
      required: false,
      default: null,
    },
    editable: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ...mapGetters({ darkThemeEnabled: 'boilerplate/darkThemeEnabled' }),
    index() {
      if (this.value === true) return 0;
      if (this.value === false) return 2;
      return 1;
    },
  },
  methods: {
    onChange(index) {
      let value = null;
      if (index === 0) value = true;
      if (index === 2) value = false;
      this.$emit('input', value);
    },
  },
};
</script>

<style scoped>
.selector >>> .selected {
  border: 3px solid rgba(0, 0, 0, 1) !important;

  padding-left: 6px;
}
.selector.dark >>> .selected {
  border-color: rgba(255, 255, 255, 1) !important;
}
</style>
